import { render, staticRenderFns } from "./PromptDialog.vue?vue&type=template&id=164b88c9&scoped=true&"
import script from "./PromptDialog.vue?vue&type=script&lang=js&"
export * from "./PromptDialog.vue?vue&type=script&lang=js&"
import style0 from "./PromptDialog.vue?vue&type=style&index=0&id=164b88c9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "164b88c9",
  null
  
)

export default component.exports